import layout from "../views/layout";

import system from "./modules/system";
import basics from "./modules/basics";
// import errPage from "../views/common/404";

//路由白名单（放路由的最后）
export const whiteRoutes = [
    //错误页面
    {
        path: "/error",
        name: "ERROR",
        meta: {
            title: "错误页面",
            icon: "",
            isNav: false,
        },
        component: { template: `<router-view/>` },
        redirect: {
            name: "ERROR_404",
        },
        children: [{
            path: "404",
            name: "ERROR_404",
            meta: {
                title: "404",
                icon: "",
                isNav: false,
            },

            component: () =>
                import ("@/views/common/404.vue"),
        }, ],
    },

    //未找到路由
    {
        path: "*",
        name: "PULL",
        meta: {
            title: "未找到路由",
            icon: "",
            isNav: false,
        },
        redirect: {
            name: "ERROR_404",
        },
        hidden: true,
    },
];

//全部一级路由
export const allRoutes = [
    //系统管理
    {
        path: "/",
        name: "HOME",
        meta: {
            title: "系统管理",
            icon: "menu-xitong",
            iconWidth: "19px",
            isNav: true,
        },
        component: layout,
        redirect: {
            name: "adminList",
        },
        children: system,
    },

    //基础配置
    {
        path: "/basics",
        name: "BASICS",
        meta: {
            title: "基础配置",
            icon: "menu-xitong",
            iconWidth: "19px",
            isNav: true,
        },
        component: layout,
        redirect: {
            name: "adminList",
        },
        children: basics,
    },

];